export const queuedTriggerMapSymbol = Symbol.for('identification_queued_trigger_map');
export const triggerApiMapSymbol = Symbol.for('identification_trigger_api_map');
export const queuedArgumentsMapSymbol = Symbol.for('identification_queued_arguments_map');
export const FALLBACK_TIMEOUT_MS = 5000;
